module.exports = __webpack_public_path__ + "static/media/logo14.94da6d3f.png";